module.exports = __webpack_public_path__ + "media/images/question_examples/question-example-open-text-multi-d95d4ae3dfb90627abc06bc49ea1f981.png";